// extracted by mini-css-extract-plugin
export default {"component-container":"auditActionsSystem_component-container__znc+f","component-caption":"auditActionsSystem_component-caption__u54zc"};